<template>
  <div>
    <h3>Deadlines Calendar</h3>
    <p>
      How many and what topics have deadlines on what dates? In this view you
      get a full overview of the entire Horizon Europe programme.
    </p>
    <div class="chart-container">
      <v-chart
        v-if="this.horizonCalendar"
        class="chart"
        :option="options"
        v-on:click="triggerSearch"
        ref="calendar"
        autoresize
      />
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { EffectScatterChart } from "echarts/charts";

import { TooltipComponent, CalendarComponent } from "echarts/components";

import VChart, { THEME_KEY } from "vue-echarts";

use([CanvasRenderer, EffectScatterChart, TooltipComponent, CalendarComponent]);

export default {
  name: "InfoGraphicsCalendar",
  components: {
    VChart,
  },
  provide: {
    [THEME_KEY]: "light",
  },
  computed: {
    horizonCalendar() {
      return this.$store.state.horizonCalendar;
    },
    options() {
      if (!this.$store.state.horizonCalendar) {
        return null;
      }

      var calendarData = this.$store.state.horizonCalendar.data;
      var calendars = this.$store.state.horizonCalendar.meta.dimensions;

      var minMax = [
        this.$store.state.horizonCalendar.meta.minCount,
        this.$store.state.horizonCalendar.meta.maxCount,
      ];

      chartOptions.calendar = this.createCalendarsConfig(calendars);
      chartOptions.series = this.createSeriesConfig(
        calendars,
        minMax,
        calendarData
      );

      return chartOptions;
    },
  },
  created: function() {
    //  if( this.horizonCalendar == null || this.horizonCalendar == '' ) {
    this.$store.dispatch("fetchHorizonCalendar");
    //  }
  },
  data() {
    return {};
  },
  methods: {
    triggerSearch: function(e) {
      if (e.data[3]) {
        this.$router.push({ path: "/" + e.data[3] });
      }
    },
    createCalendarsConfig(calendars) {
      var calendarsConfig = [];
      for (var id in calendars) {
        calendarsConfig.push({
          range: calendars[id],
          top: 30 + id * 200,
          left: "50",
          cellSize: ["auto", 20],
          right: 5,
        });
      }
      return calendarsConfig;
    },
    createSeriesConfig(calendars, minMax, calendarData) {
      var seriesConfig = [];
      for (var id in calendars) {
        var item = {
          type: "effectScatter",
          coordinateSystem: "calendar",
          calendarIndex: id,
          data: calendarData,
          color: "#eb3d34",
          symbolSize: function(val) {
            var oldMin = minMax[0];
            var oldMax = minMax[1];
            var newMin = 5;
            var newMax = 20;
            return (
              (val[1] - oldMin) * ((newMax - newMin) / (oldMax - oldMin)) +
              newMin
            );
          },
        };
        seriesConfig.push(item);
      }
      return seriesConfig;
    },
  },
};

var chartOptions = {
  tooltip: {
    formatter: function(params) {
      var listTopics = "";
      for (var topicId in params.value[2]) {
        if (topicId <= 10) {
          listTopics = listTopics + "<br>" + params.value[2][topicId]["id"];
        }
        if (topicId == 11) {
          listTopics = listTopics + "<br>       ...";
        }
      }
      return (
        "<b>" +
        params.value[1] +
        " topics with deadline on " +
        params.value[0] +
        "</b> <br>List of Topics:" +
        listTopics
      );
    },
  },
  calendar: [],
  series: [],
};
</script>

<style scoped>
.chart {
  width: 95%;
  height: 1600px;
}
.chart-container {
  height: 700px;
  overflow: scroll;
}
</style>
